export const CONTACT_PERMISSION_ERROR = "ERR_NO_CONTACT_PERMISSION";

const CONTACT_WALLET_KEYS = [
  "walletUserIds",
  "userIds",
  "walletUserId",
  "userId",
  "user_id",
  "wallet_user_id",
  "contact_user_id",
  "walletUsers",
  "walletUser",
  "users",
  "user",
  "wallet",
  "wallets",
  "contactWalletUsers",
  "contactWallets",
  "contactUsers",
  "contactUser",
  "contactUserId",
  "WalletUsers",
  "WalletUser",
  "Users",
  "User",
  "Wallet",
  "Wallets",
  "ContactWalletUsers",
  "ContactWallets",
  "ContactUsers",
  "ContactUser",
];

const USER_NESTED_KEYS = [
  "user",
  "walletUser",
  "contactUser",
  "User",
  "WalletUser",
  "ContactUser",
];

const normalizeUser = (userLike) => {
  if (typeof userLike === "number" || typeof userLike === "string") {
    return {
      id: userLike,
      name: `#${userLike}`,
    };
  }

  if (!userLike || typeof userLike !== "object") {
    return null;
  }

  const userId =
    userLike.id ||
    userLike.userId ||
    userLike.walletUserId ||
    userLike.contactUserId ||
    userLike.user_id ||
    userLike.wallet_user_id ||
    userLike.contact_user_id ||
    userLike.user?.id ||
    userLike.walletUser?.id ||
    userLike.contactUser?.id ||
    userLike.User?.id ||
    userLike.WalletUser?.id ||
    userLike.ContactUser?.id;
  const userName =
    userLike.name ||
    userLike.userName ||
    userLike.username ||
    userLike.user?.name ||
    userLike.walletUser?.name ||
    userLike.contactUser?.name ||
    userLike.User?.name ||
    userLike.WalletUser?.name ||
    userLike.ContactUser?.name;

  if (!userId && !userName) {
    return null;
  }

  return {
    id: userId,
    name: userName || `#${userId}`,
  };
};

const extractUsersFromArray = (list = []) =>
  list
    .flatMap((item) => {
      const directUser = normalizeUser(item);

      if (directUser) {
        return [directUser];
      }

      return USER_NESTED_KEYS.map((key) => normalizeUser(item?.[key])).filter(Boolean);
    })
    .filter(Boolean);

export const getContactWalletUsers = (contact = {}) => {
  const users = CONTACT_WALLET_KEYS.flatMap((key) => {
    const value = contact?.[key];
    if (Array.isArray(value)) {
      return extractUsersFromArray(value);
    }

    const normalized = normalizeUser(value);
    return normalized ? [normalized] : [];
  });

  return users.filter(
    (user, index, self) =>
      index === self.findIndex((candidate) => candidate.id === user.id && candidate.name === user.name)
  );
};

export const getContactWalletUserIds = (contact = {}) =>
  getContactWalletUsers(contact)
    .map((user) => user.id)
    .filter(Boolean);

export const isRestrictedContact = (contact = {}) => getContactWalletUsers(contact).length > 0;

export const hasContactWalletMetadata = (contact = {}) =>
  CONTACT_WALLET_KEYS.some((key) => Object.prototype.hasOwnProperty.call(contact || {}, key));

export const buildContactWalletPayload = (walletUserIds = []) => {
  const ids = Array.isArray(walletUserIds)
    ? walletUserIds.filter(Boolean).map((id) => Number(id) || id)
    : [];

  return {
    userIds: ids,
  };
};

export const isNoContactPermissionError = (err) =>
  err?.response?.status === 403 &&
  err?.response?.data?.error === CONTACT_PERMISSION_ERROR;
